import { Component } from '@angular/core';

@Component({
  selector: 'sobreMi',
  templateUrl: './sobreMi.component.html',
  styleUrls: ['./sobreMi.component.css']
})
export class SobreMiComponent {
}
